import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { jwtDecode } from 'jwt-decode';
import { LoginResultDto } from '../data-models/identity.data.models';
import { SignalrService } from 'src/app/shared/services/signalr.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private _currentUserCredantials?: LoginResultDto;
  /** Set when login succeeds but a mandatory password change is required before entering the app. */
  pendingLoginBeforeReset?: LoginResultDto;
  /** Portal session returned by investor registration; used by "Continue on Web" on the success step. In memory only. */
  pendingInvestorLogin?: LoginResultDto;
  menuTree: any[] = [];

  private tokenKey = 'authToken';
  constructor(
    private router: Router,
    private signalrService: SignalrService
  ) { }

  getCurrentSystemLanguage(): string {
    let language = localStorage.getItem('language');
    if (language) return language;
    else {
      localStorage.setItem('language', 'en-US');
      return 'en-US';
    }
  }
  setLanguage(language: string) {
    localStorage.setItem('language', language);
  }

  get currentUserCredantials(): LoginResultDto {
    if (localStorage.getItem("currentUser")) {
      return JSON.parse(localStorage.getItem("currentUser") as string) as LoginResultDto;
    }
    else
      return undefined!;

  }
  set currentUserCredantials(value: LoginResultDto | undefined) {
    if (value && value.expiryTokenInMinutes) {
      var expiryDate = new Date();
      expiryDate.setMinutes(expiryDate.getMinutes() + value.expiryTokenInMinutes! - 5);
      value.expiryTokenDate = expiryDate;
    }
    this._currentUserCredantials = value == undefined ? value : JSON.parse(JSON.stringify(value));
    localStorage.setItem("currentUser", this._currentUserCredantials ? JSON.stringify(this._currentUserCredantials) : "");

  }

  isLoggedIn(): boolean {
    if (this.currentUserCredantials)
      return true;
    else
      return false;
  }

  logout() {
    this.clearLocalStorage();
    //this.signalrService.stopConnection();
    this.router.navigate(['/authentication/login']).then(() => {
      window.location.reload();
    });
    //this.router.navigateByUrl('/authentication/login', { replaceUrl: true });

  }
  clearLocalStorage() {
    this._currentUserCredantials = undefined;
    const preserveKeys = ['currentLang', 'language', 'lang'] as const;
    const preserved: Record<string, string | null> = {};
    for (const key of preserveKeys) {
      preserved[key] = localStorage.getItem(key);
    }
    localStorage.clear();
    for (const key of preserveKeys) {
      const v = preserved[key];
      if (v != null) {
        localStorage.setItem(key, v);
      }
    }
    sessionStorage.removeItem(this.tokenKey);
  }

setToken(token: string) {
  localStorage.setItem('authToken', token);
}

getToken(): string | null {
  return localStorage.getItem('authToken');
}

clearToken() {
  localStorage.removeItem('authToken');
}
setMenuTree(menu: any[]) {
  this.menuTree = menu;
}

getMenuTree() {
  return this.menuTree;
}

}
